import { FixtureItem } from './types';

// Convert fixtureByIdMap to an array of FixtureItem objects
export const fixtures: FixtureItem[] = [
  {
    id: 'walmart-texture',
    name: 'Walmart Texture GLB',
    color: '#0071ce',
    size: { width: 0.5, height: 0.5 },
    category: 'Demo',
    imageUrl: './walmart-thumbnail.png',
    figure: {
      id: 4,
      key: 'walmart-texture',
      name: 'Walmart Texture',
      type: 'fixture',
      som: 'imperial',
      w: 0.5,
      d: 0.5,
      h: 1.2,
      category: 'Demo',
      renders: {
        front: './walmart-texture.glb',
        topdown_l: './walmart-texture.glb',
        topdown_lR90: './walmart-texture.glb',
        topdown_lR180: './walmart-texture.glb',
        topdown_lR270: './walmart-texture.glb',
        topdown_r: './walmart-texture.glb',
        topdown_rR90: './walmart-texture.glb',
        topdown_rR180: './walmart-texture.glb',
        topdown_rR270: './walmart-texture.glb',
      },
    },
  },
];
